import { Schema } from 'normalizr';

export const shotAdSlotsSchema = new Schema('shotAdSlots', { idAttribute: 'storyId' });
